<template>
    <div class="left-aside">
       <!-- <el-aside width="150px"> -->
             <div class="title"  >
                 <!-- <img v-show="isMenu" src="https://5a-oss.qdlyjt.cn/5a/images/23-03-04/b096f5d0720de481893273a99a9ebd5c64029e1e97e36.jpg" class="tu"/> -->
                 <span v-show="isMenu" style="color:#fff;font-weight: bold;">青岛奥帆海洋文化旅游区</span>
             </div>
             <el-menu
                default-active="0"
                class="el-menu-vertical-demo"
                background-color="#213450"
                text-color="#fff"
                active-text-color="#8F97B3 "
                 >
                 <router-link to="/admin">
                     <el-menu-item index="1" >
                             <i class="el-icon-s-home"></i>
                             <span v-show="isMenu">首页</span>
                     </el-menu-item>
                 </router-link>

                 <el-submenu index="2">
                     <template slot="title">
                         <i class="el-icon-s-comment"></i>
                         <span slot="title" v-show="isMenu">店铺管理</span>
                     </template>
                     <el-menu-item-group>
                         <router-link to="/shop/list">
                            <el-menu-item index="2-1" v-show="isMenu">店铺列表</el-menu-item>
                         </router-link>
                         <router-link to="/shop/examine">
                            <el-menu-item index="2-2" v-show="isMenu">店铺审核</el-menu-item>
                         </router-link>
                         <router-link to="/shop/classification">
                            <el-menu-item index="2-3" v-show="isMenu">店铺分类</el-menu-item>
                         </router-link>
                     </el-menu-item-group>
                 </el-submenu>
               <el-submenu index="3">
                 <template slot="title">
                   <i class="el-icon-s-comment"></i>
                   <span slot="title" v-show="isMenu">商品管理</span>
                 </template>
                 <el-menu-item-group>
                   <router-link to="/goods/list">
                     <el-menu-item index="3-1" v-show="isMenu">商品列表</el-menu-item>
                   </router-link>
                   <router-link to="/goods/goodexamine">
                     <el-menu-item index="3-2" v-show="isMenu">商品审核</el-menu-item>
                   </router-link>
                   <router-link to="/goods/goodsCategory">
                     <el-menu-item index="3-3" v-show="isMenu">商品分类</el-menu-item>
                   </router-link>
                   <router-link to="/goods/goodsLabel">
                     <el-menu-item index="3-4" v-show="isMenu">商品标签</el-menu-item>
                   </router-link>
                 </el-menu-item-group>
               </el-submenu>
               <router-link to="/restaurant">
                     <el-menu-item index="14" >
                             <i class="el-icon-s-home"></i>
                             <span v-show="isMenu">外部餐饮</span>
                     </el-menu-item>
                 </router-link>
                 <router-link to="/wineshop">
                     <el-menu-item index="10" >
                             <i class="el-icon-s-home"></i>
                             <span v-show="isMenu">外部酒店</span>
                     </el-menu-item>
                 </router-link>
               <el-submenu index="4">
                 <template slot="title">
                   <i class="el-icon-s-comment"></i>
                   <span slot="title" v-show="isMenu">购物订单</span>
                 </template>
                 <el-menu-item-group>
                   <router-link to="/shopOrder/orderList">
                     <el-menu-item index="4-1" v-show="isMenu">订单列表</el-menu-item>
                   </router-link>
                   <router-link to="/shopOrder/refundApplication">
                     <el-menu-item index="4-2" v-show="isMenu">退款申请记录</el-menu-item>
                   </router-link>
                   <router-link to="/shopOrder/express">
                     <el-menu-item index="4-3" v-show="isMenu">快递信息</el-menu-item>
                   </router-link>
                   <router-link to="/shopOrder/refundRecord">
                     <el-menu-item index="4-4" v-show="isMenu">退款记录</el-menu-item>
                   </router-link>
                 </el-menu-item-group>
               </el-submenu>

               <el-submenu index="5">
                 <template slot="title">
                   <i class="el-icon-s-comment"></i>
                   <span slot="title" v-show="isMenu">订单统计</span>
                 </template>
                 <el-menu-item-group>
                   <router-link to="/statistics/goods_stat">
                     <el-menu-item index="5-1" v-show="isMenu">购物订单统计</el-menu-item>
                   </router-link>
                   <router-link to="/statistics/sales_stat">
                     <el-menu-item index="5-2" v-show="isMenu">店铺销量统计</el-menu-item>
                   </router-link>
                   <router-link to="/statistics/revenue_stat">
                     <el-menu-item index="5-3" v-show="isMenu">店铺营收统计</el-menu-item>
                   </router-link>
                 </el-menu-item-group>
               </el-submenu>
               <el-submenu index="8">
                 <template slot="title">
                   <i class="el-icon-s-tools"></i>
                   <span slot="title">系统配置</span>
                 </template>
                 <el-menu-item-group>
                  <router-link to="/system/list">
                     <el-menu-item index="8-2">平台列表</el-menu-item>
                   </router-link>
                   <!-- <router-link to="/system/payment">
                     <el-menu-item index="8-2">支付配置</el-menu-item>
                   </router-link> -->
                   <router-link to="/system/banner">
                     <el-menu-item index="8-3">Banner管理</el-menu-item>
                   </router-link>
                 </el-menu-item-group>
               </el-submenu>
                 <el-submenu index="9">
                   <template slot="title">
                     <i class="el-icon-s-comment"></i>
                     <span slot="title" v-show="isMenu">信息中心</span>
                   </template>
                   <el-menu-item-group>
                     <router-link to="/message/user">
                        <el-menu-item index="9-1" v-show="isMenu">用户信息</el-menu-item>
                     </router-link>
                     <router-link to="/message/admin">
                        <el-menu-item index="9-2" v-show="isMenu">管理员信息</el-menu-item>
                     </router-link>
                   </el-menu-item-group>
                 </el-submenu>
                 <el-submenu index="15">
                 <template slot="title">
                   <i class="el-icon-s-tools"></i>
                   <span slot="title" v-show="isMenu">用户日志</span>
                 </template>
                 <el-menu-item-group>
                   <router-link to="/record/login">
                     <el-menu-item index="15-1" v-show="isMenu">登录日志</el-menu-item>
                   </router-link>
                   <router-link to="/record/operate">
                     <el-menu-item index="15-2" v-show="isMenu">操作日志</el-menu-item>
                   </router-link>
                 </el-menu-item-group>
               </el-submenu>
             </el-menu>
         <!-- </el-aside> -->
   </div>
 </template>
 
 <script>
 export default {
     props:['isMenu']
 }
 </script>
 
 <style scoped lang="scss">
 .left-aside{
     height: 100%;
     border-right: 1px solid rgb(232, 230, 230);
     background-color: #213450;
 }
 .title{
     display: flex;
     align-items: center;
     justify-content: center;
     background-color:#1b2c43;
     height: 60px;
 }
 .el-menu-item:hover{
     outline: 0 !important;
     background-color: #4e5f79 !important
 }
 .el-menu{
     border-right:none !important
 }

 .el-menu-item{
   height: 46px !important;
   line-height: 46px !important;
   list-style: none;
 }
 
 </style>